import Errors from '../../errors'

export default {
  $$ERRORS: Errors
}
